import React from 'react';
import { NewTripRequest } from '../../types';

interface StepProps {
  formData: NewTripRequest;
  setFormData: React.Dispatch<React.SetStateAction<NewTripRequest>>;
}

const StepBudgetTransport: React.FC<StepProps> = ({ formData, setFormData }) => {
  
  const handleBudgetChange = (value: string) => {
    // Value is in string representation of dollars, convert to cents
    if (!value) {
        setFormData(prev => ({ ...prev, budget: undefined }));
        return;
    }
    const dollars = parseFloat(value);
    if (!isNaN(dollars)) {
        setFormData(prev => ({ ...prev, budget: Math.round(dollars * 100) }));
    }
  };

  const transportOptions = [
    { value: 'public transit', label: 'Public Transit', icon: '🚇' },
    { value: 'rental car', label: 'Rental Car', icon: '🚗' },
    { value: 'walking', label: 'Walking', icon: '🚶' },
    { value: 'biking', label: 'Biking', icon: '🚲' },
    { value: 'taxis', label: 'Taxis / Rideshare', icon: '🚕' },
    { value: 'tour bus', label: 'Tour Bus', icon: '🚌' }
  ];

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      
      {/* Budget */}
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-gray-900">Total Trip Budget</h3>
        <p className="text-sm text-gray-500">Estimated total budget for the trip (excluding flights usually).</p>
        
        <div className="relative max-w-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500 text-lg">$</span>
            </div>
            <input
                type="number"
                min="0"
                step="0.01"
                value={formData.budget !== undefined ? formData.budget / 100 : ''}
                onChange={(e) => handleBudgetChange(e.target.value)}
                className="block w-full pl-8 rounded-xl border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 py-3 text-lg"
                placeholder="0.00"
            />
             <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <span className="text-gray-400 text-sm">USD</span>
            </div>
        </div>
      </div>

      <div className="border-t border-gray-100 pt-4"></div>

      {/* Transportation */}
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-gray-900">Transportation Preference</h3>
        <p className="text-sm text-gray-500">How do you prefer to get around during your trip?</p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {transportOptions.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    onClick={() => setFormData(prev => ({ ...prev, transportationPreference: option.value }))}
                    className={`flex items-center gap-3 p-4 rounded-xl border transition-all text-left ${
                        formData.transportationPreference === option.value
                        ? 'border-primary-500 bg-primary-50 text-primary-900 shadow-sm ring-1 ring-primary-500'
                        : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50 text-gray-700'
                    }`}
                >
                    <span className="text-2xl">{option.icon}</span>
                    <span className="font-medium">{option.label}</span>
                </button>
            ))}
        </div>
      </div>

    </div>
  );
};

export default StepBudgetTransport;

